import { HTMLAttributes } from 'react';
import { useJoveBreakpoint } from '@jove-frontend/uikit';
import { Box, Typography } from '@mui/material';
import clsx from 'clsx';

export interface BrokerActurisGetQuotesInterface {
  acturisSectionTitle: string;
  acturisTitle: string;
  acturisDesc: string;
  acturisIntroductionImageUrl: string;
}

type BrokerActurisGetQuotesViewProps = HTMLAttributes<HTMLDivElement> & {
  info: BrokerActurisGetQuotesInterface;
};
const BrokerActurisGetQuotesView = (props: BrokerActurisGetQuotesViewProps) => {
  const { className, info } = props;
  const { isMobileLayout } = useJoveBreakpoint();

  return (
    <Box
      className={clsx('flex flex-row overflow-hidden rounded-3xl bg-white pl-8', className, isMobileLayout ? 'min-h-[400px]' : 'h-[400px]')}
      style={{ boxShadow: '0 8px 16px 0 rgba(0, 0, 0, 0.1)' }}
    >
      <Box className="flex flex-1 flex-col justify-center space-y-4">
        <Box className="flex flex-row self-start rounded-full bg-[#EBEFFE] px-3 py-2">
          <Typography variant="subtitle1" className="text-brand-secondary font-extrabold">
            {info?.acturisSectionTitle}
          </Typography>
        </Box>
        <Typography variant="h5" className="text-primary-black font-black">
          {info?.acturisTitle}
        </Typography>
        <Typography variant="subtitle1" className="text-primary-black text-lg">
          {info?.acturisDesc}
        </Typography>
      </Box>
      {!isMobileLayout && <img width="auto" height="100%" src={info?.acturisIntroductionImageUrl} />}
    </Box>
  );
};

export default BrokerActurisGetQuotesView;
